import React, { useMemo } from 'react';
import { Modal, Result, Card, Tag, Typography, Divider, Button, Tooltip } from 'antd';
import { WarningOutlined, FilterOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { normalizePhoneNumber, processPhoneNumbers } from '../../CustomUtils.js/CampaignUtils';

const BlockedNumbersModal = ({
  isVisible,
  blockedNumbersSample,
  handleRemoveBlockedNumbers,
  handleCloseBlockedModal,
  allNumbers,
  blockNumbers,
  number,
}) => {
  const allNumbersBlocked = useMemo(() => {
    if (!blockNumbers) return false;

    const blockedSet = new Set(
      (blockNumbers || []).map(normalizePhoneNumber).filter(Boolean)
    );

    // Start with the group numbers
    let combinedNumbers = [...(allNumbers || [])];

    // Process numbers from text input if present
    if (number && number?.trim()) {
      const numbersFromInput = processPhoneNumbers(number);

      // Add the input numbers to the combined list
      combinedNumbers = [...combinedNumbers, ...numbersFromInput];
    }

    // Check if there are any valid numbers
    const normalizedCombined = combinedNumbers
      .map(normalizePhoneNumber)
      .filter(Boolean);

    if (normalizedCombined.length === 0) return false;

    // Check if all numbers are blocked
    return normalizedCombined.every(num => blockedSet.has(num));
  }, [allNumbers, blockNumbers, number]);

  return (
    <Modal
      open={isVisible}
      footer={null}
      closable={false}
      width={500}
      centered
    >
      <Result
        status="warning"
        title={<Typography.Title level={5}>Unsubscribed Numbers Found</Typography.Title>}
        subTitle="This campaign contains numbers that have unsubscribed. Messages will not be sent to these numbers."
        style={{ padding: '12px 0' }}
        icon={<WarningOutlined style={{ fontSize: '35px' }} />}
      />

      <Card
        title="Some of blocked numbers"
        size="small"
        style={{ marginBottom: '16px' }}
        bodyStyle={{ maxHeight: '150px', overflow: 'auto' }}
      >
        {blockedNumbersSample?.map((num, index) => (
          <Tag
            color='red'
            key={index}
            style={{
              margin: '4px',
              fontSize: '14px',
              padding: '4px 8px',
              borderRadius: '4px',
              background: '#fff2e8',
              borderColor: '#ffbb96'
            }}
          >
            {num}
          </Tag>
        ))}
        {blockedNumbersSample?.length >= 5 && (
          <Typography.Text type="secondary" style={{ display: 'block', marginTop: '8px' }}>
            ...and more blocked numbers not shown
          </Typography.Text>
        )}
      </Card>
      
      <Divider style={{ margin: '16px 0' }} />

      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button
          type="primary"
          icon={<FilterOutlined />}
          onClick={handleRemoveBlockedNumbers}
        >
          Remove Blocked Numbers
        </Button>
        <Tooltip
          title={allNumbersBlocked ? "No valid numbers to process" : ""}
          placement="top"
        >
          <Button
            icon={<CheckCircleOutlined />}
            onClick={handleCloseBlockedModal}
            disabled={allNumbersBlocked}
          >
            Continue Without Removing
          </Button>
        </Tooltip>
      </div>
    </Modal>
  );
};

export default BlockedNumbersModal;